export const defaultRoutes = [
  {
    path: '/',
    name: 'listing',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
  },
  {
    path: '/v2/experience/:citySlug/:tag?/',
    name: 'cityListingV2',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'city',
      soguName: 'listing',
    },
  },
  {
    path: '/experience/:citySlug/:tag?/',
    name: 'cityListing',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'city',
      soguName: 'listing',
    },
  },
  {
    name: 'tours-in-country-from-city-listing',
    path: `/tours/:countrySlug/iz/:citySlug/`,
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'country',
      soguName: 'destinations-country',
      isFromCityPage: true,
    },
  },
  {
    name: 'tours-in-country-from-city-listing-v2',
    path: `/v2/tours/:countrySlug/iz/:citySlug/`,
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'country',
      soguName: 'destinations-country',
      isFromCityPage: true,
    },
  },
  {
    name: 'tours-in-region-from-city-listing',
    path: '/tours/:country/:regionSlug/iz/:citySlug/',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'region',
      soguName: 'destinations-region',
      isFromCityPage: true,
    },
  },
  {
    path: '/tours/city/:citySlug/:tag?/',
    name: 'cityTourListing',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'city',
      soguName: 'destinations-city',
    },
  },
  {
    path: '/tours/:countrySlug/',
    name: 'countryListing',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'country',
      soguName: 'destinations-country',
    },
    children: [
      {
        component: () => import('@/pages/listing/ui/ListingPage.vue'),
        meta: {
          checkGeoParam: true,
          destinationType: 'country',
          hasTours: true,
          soguName: 'destinations-country',
        },
        name: 'tours-country-tag',
        path: `tags/:tag/`,
      },
    ],
  },
  {
    path: '/v2/tours/:countrySlug/',
    name: 'countryListingV2',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'country',
      soguName: 'destinations-country',
    },
    children: [
      {
        component: () => import('@/pages/listing/ui/ListingPage.vue'),
        meta: {
          checkGeoParam: true,
          destinationType: 'country',
          hasTours: true,
          soguName: 'destinations-country',
        },
        name: 'tours-country-tag-v2',
        path: `tags/:tag/`,
      },
    ],
  },
  {
    path: '/tours/:country/:regionSlug/:tag?/',
    name: 'regionListing',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'region',
      soguName: 'destinations-region',
    },
  },
  {
    path: '/v2/tours/:country/:regionSlug/:tag?/',
    name: 'regionListingV2',
    component: () => import('@/pages/listing/ui/ListingPage.vue'),
    meta: {
      title: 'Tripster',
      destinationType: 'region',
      soguName: 'destinations-region',
    },
  },
];
